import { lazy } from "react"

export const UserById = lazy(() => import("./UserById"))
